module.exports = __webpack_public_path__ + "img/icon-estrella-on.6db91aa5.svg";